import styled from 'styled-components';

type ContainerPropsType = {
  spacing?: string;
};
export const Container = styled.div<ContainerPropsType>`
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: ${(props) => (props.spacing ? props.spacing : 0)};
  padding: 0 14px;
`;

export const Row = styled.div`
  display: flex;
  gap: 20px;
`;
type ContentPropsType = {
  flexGrow?: number;
  flexBasis?: string;
};

export const Content = styled.div<ContentPropsType>`
  flex-grow: ${(props) => (props.flexGrow ? props.flexGrow : 0)};
  flex-basis: ${(props) => (props.flexBasis ? props.flexBasis : 'auto')};
`;

export const LoadingContainer = styled.div`
  height: 370px;
  @media (min-width: 768px) {
    // height: 
  }
`;
